module.exports = __webpack_public_path__ + "static/img/bug.60f3a83.png";